var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{staticClass:"fill-height"},[_c('canvas',{ref:"containerBalanceChart",staticClass:"pr-md-2 pl-md-2",attrs:{"id":"container-balance-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }